import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Link } from 'react-router-dom';

import Users from '../users/Users';
import UserPage from '../user/User';
import Categories from '../user/categories/Categories';
import Category from '../user/categories/Category';
import { withLocalize, Translate } from "react-localize-redux";
var userTranslations = require("../../translations/user.json")
var campaignTranslations = require("../../translations/campaign.json")

import { toast } from 'react-toastify';



class UsersRouter extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.props.addTranslation(userTranslations)
    this.props.addTranslation(campaignTranslations)

  }

  exportUsers(event:any) {
    event.preventDefault()
    fetch('users/export', {
      method: 'POST'
    }).then((response: any) => {
      return response.blob()
    }).then((blob: any) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.style.display = "none"
      a.href = url;
      a.download = "users.csv";
      document.body.appendChild(a);
      a.click();
      a.remove();
    }).catch(err => {
      toast.error(err.message);
    })
  }

  public render() {
    return (
      <div id="users-router-root">
        <div className="buttonsHeader">
          <Link to="/users/new"><button><Translate id="user.newUser" /></button></Link>
          <Link to="/users/categories"><button><Translate id="user.categories" /></button></Link>
          <Link to="/users/categories/new"><button><Translate id="user.newCategory" /></button></Link>
          <button onClick={this.exportUsers.bind(this)}><Translate id="export" /></button>
        </div>

        <Switch>
          <Route exact path={`/users`} component={Users} />
          <Route exact path={`/users/categories`} component={Categories} />
          <Route exact path={`/users/categories/new`} component={Category} />
          <Route exact path={`/users/categories/:id`} component={Category} />
          <Route exact path={`/users/new`} component={UserPage} />
          <Route exact path={`/users/:id`} component={UserPage} />

        </Switch>

      </div>
    );
  }
}

export default withLocalize(UsersRouter)



// WEBPACK FOOTER //
// ./src/pages/home/UsersRouter.tsx